import { NuvoBox } from '@nuvolo/nuux-core/components/NuvoBox';
import { color } from '@nuvolo/nuux-theme/utils';
import styled, { css } from 'styled-components';
import { borderRadius } from '../hooks/useClientTheme';

export const StyledNuvoBox = styled(NuvoBox)<{ isDesktop?: boolean }>`
  margin: 0 !important;
  padding: 0 !important;

  #tmm-section-no-background,
  #tmm-section {
    margin: 0 !important;
    padding: 0 !important;
    border: 1px solid ${color('primary', 'light3')} !important;
    border-radius: 20px;
    padding: 20px !important;
    background-color: ${color('custom', 'dataGridBackground')};
    margin-top: 8px;
    position: relative;

    .dx-field-item-label-text {
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      color: ${color('primary', 'dark')};
      height: 70px;
      margin-bottom: 6px;
    }

    .dx-textbox,
    .dx-texteditor,
    .dx-htmleditor.dx-htmleditor-outlined {
      box-shadow: none !important;
      background-color: transparent !important;
    }

    input,
    textarea {
      border: 1px solid ${color('primary', 'light3')};
      border-radius: ${borderRadius?.s};
      padding: 12px 16px;
      background-color: ${color('custom', 'formInputBackground', 0.5)};

      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      color: ${color('primary', 'dark')};
    }

    img {
      aspect-ratio: 4 / 3 !important;
      height: 100% !important;
      object-fit: contain;
    }

    .dx-form-group-caption {
      position: absolute;
      top: -40px;
      left: 0;
      font-size: 20px;
      font-weight: 500;
      line-height: 26px;
      height: 26px;
      color: ${color('primary', 'dark')};
      padding: 0;
    }

    .hide-label > label {
      display: none !important;
    }

    margin-bottom: 16px !important;

    .tmm-section-panel > div {
      .icon-wrapper {
        background-color: ${color('custom', 'constantIconBlue', 0.15)} !important;
        border-radius: ${borderRadius?.s} !important;
        // border radius design is 12px - use borderRadius.s which is 16px
      }
      div:not(.dx-radiobutton-icon):not(.dx-radiobutton-icon-dot) {
        background-color: transparent !important;

        .dx-list-item-selected > div > div:first-child {
          /* border: 1px solid ${color('primary', 'light3')} !important; */
        }
      }

      .dx-item.dx-list-item {
        &.dx-state-hover,
        &.dx-state-focused,
        &.dx-list-item-selected {
          background-color: ${color('custom', 'focusItemBackground')} !important;

          .item-container,
          .item-container > div,
          .item-container > div > div {
            background-color: ${color('custom', 'focusItemBackground')} !important;
          }
        }
      }
    }
  }

  #tmm-section-no-background {
    background-color: transparent !important;
    border: none !important;
    padding: 0 !important;

    .organization-wrapper {
      div:first-child {
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
      }

      div {
        border: none !important;
        background-color: transparent !important;
        color: ${color('custom', 'mediumGray')} !important;

        input {
          color: ${color('custom', 'mediumGray')} !important;
        }
      }
    }
  }

  #tmm-section-no-caption {
    margin: 16px !important;
  }

  .dropdown-field {
    border: none !important;

    input {
      width: 100% !important;
      padding-right: 50px !important;
      position: relative;
    }
  }

  .dropdown-field > div > div > div:nth-child(2) {
    position: absolute;
    margin: 0;
    right: 0;
    height: 100%;
    width: fit-content;
    color: ${color('secondary', 'dark')} !important;
  }

  .dropdown-field > div > div > div:nth-child(2) > div:nth-child(2) {
    margin: 0 auto;
    padding-right: 50px !important;
  }

  #selected-asset-card {
    border-radius: 24px;
    background-color: ${color('custom', 'dataGridBackground')};

    div {
      ${({ isDesktop }) =>
        !isDesktop
          ? css`
              flex-direction: column !important;
              width: 100%;
              img {
                margin-top: 16px;
                width: 100%;
              }
            `
          : ''}

      padding: 0;
      margin: 0;
      background: transparent;
      border: none;
    }
  }

  #selector-row {
    div:first-child {
      font-weight: 500;
      font-size: 16px;
      line-height: 22px;
      color: ${color('primary', 'dark')};
    }

    div:nth-child(2) {
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      color: ${color('primary', 'middle')};
    }

    position: relative;
  }

  .section-label > div {
    font-weight: 500;
    font-size: 20px;
    line-height: 26px;
    color: ${color('primary', 'dark')};
    margin: 32px 0 8px 0;
  }

  .box-caption {
    margin-bottom: 12px;

    div:first-child {
      font-size: 20px;
      font-weight: 500;
      line-height: 26px;
      height: 26px;
      color: ${color('primary', 'dark')};
      padding: 0;
    }
  }
`;
